<template>
  <FlotoLink
    id="main-content"
    class="back-button"
    :aria-label="$t('back')"
    v-bind="$attrs"
  >
    <MIcon
      :name="`chevron-${isRtl ? 'right' : 'left'}`"
      size="lg"
      style="position: unset"
    />
  </FlotoLink>
</template>

<script>
import { authComputed } from '@state/modules/auth'

export default {
  name: 'FlotoBackButton',
  computed: {
    ...authComputed,
  },
}
</script>

<style lang="less">
.back-button {
  @apply flex items-center justify-center;

  width: 20px;
  height: 20px;
  margin-left: 0;
  font-size: 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;

  &:hover {
    color: var(--text-neutral-ligher);
  }
}
</style>
